import React from "react";
import { Mail, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { EVENT, LINKS } from "../data/content";
import { NAV_PAGES, PAGES } from "../seo/pages";

export const Footer = () => (
  <footer className="bg-mds-greendeep px-5 py-16 text-mds-cream sm:px-8" data-testid="footer">
    <div className="mx-auto max-w-[1200px]">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Link to="/" className="inline-flex flex-col items-center" data-testid="footer-home-link" aria-label="Million Dollar Shot home">
            <img src="/brand/logo-cream.png" alt="Million Dollar Shot" className="w-[210px] object-contain" draggable={false} />
            <p className="mt-3 font-display text-lg italic text-mds-cream/85">
              Benefiting <span className="font-bold not-italic">Naples Cancer Advisors</span>
            </p>
          </Link>
          <p className="mt-5 font-body text-sm font-bold text-mds-cream/70">
            {EVENT.date} · {EVENT.time}
            <br />
            {EVENT.venue}, {EVENT.city}
          </p>
        </div>

        <div className="lg:col-span-3">
          <p className="font-sans text-[10px] font-semibold uppercase tracking-[0.18em] text-mds-goldlt">For More Information</p>
          <p className="mt-4 font-display smallcaps text-xl font-bold text-mds-cream">Nikki Audia</p>
          <p className="font-body text-sm text-mds-cream/70">Director of Philanthropy & Community Engagement</p>
          <div className="mt-5 space-y-3">
            <a href={`mailto:${LINKS.contactEmail}`} className="flex items-center gap-3 font-body text-sm text-mds-cream/80 transition-colors hover:text-mds-goldlt" data-testid="footer-email">
              <Mail size={15} /> {LINKS.contactEmail}
            </a>
            <a href={`tel:${LINKS.phone}`} className="flex items-center gap-3 font-body text-sm text-mds-cream/80 transition-colors hover:text-mds-goldlt" data-testid="footer-phone">
              <Phone size={15} /> {LINKS.phone}
            </a>
          </div>
        </div>

        <div className="lg:col-span-4">
          <p className="font-sans text-[10px] font-semibold uppercase tracking-[0.18em] text-mds-goldlt">Get Involved</p>
          <div className="mt-4 flex flex-col gap-3">
            <a href="https://secure.qgiv.com/event/mdsnaples2026" target="_blank" rel="noopener noreferrer" className="font-display smallcaps text-2xl text-mds-cream transition-colors hover:text-mds-goldlt" data-testid="footer-tickets">Reserve a Table</a>
            <a href="https://secure.qgiv.com/event/mdsnaples2026" target="_blank" rel="noopener noreferrer" className="font-display smallcaps text-2xl text-mds-cream transition-colors hover:text-mds-goldlt" data-testid="footer-ticket">Reserve a Ticket</a>
            <Link to="/champions" className="font-display smallcaps text-2xl text-mds-cream transition-colors hover:text-mds-goldlt" data-testid="footer-donate">Donate to a Champion</Link>
            <a href={`mailto:${LINKS.contactEmail}?subject=${encodeURIComponent("Count Me In as a Champion!")}&body=${encodeURIComponent("Write your message to Nikki here to let her know that you would like to be a Champion for Million Dollar Shot Fort Myers and support Naples Cancer Advisors. Please include your name, email, phone, and a little about yourself. Nikki will follow up with you soon.")}`} className="font-display smallcaps text-2xl text-mds-cream transition-colors hover:text-mds-goldlt" data-testid="footer-champion">Become a Champion</a>
            <Link to="/sponsors" className="font-display smallcaps text-2xl text-mds-cream transition-colors hover:text-mds-goldlt" data-testid="footer-sponsor">Become a Sponsor</Link>
          </div>
        </div>
      </div>

      <p className="gold-glimmer mt-12 text-center font-sans text-[11px] font-extrabold uppercase tracking-[0.16em]" data-testid="footer-soldout-note">
        Limited Tables and Individual Seats Remaining — VIP Tables and VIP Seats SOLD OUT
      </p>

      <nav className="mt-6 flex flex-wrap items-center justify-center gap-x-7 gap-y-3 border-t border-mds-cream/15 pt-8" data-testid="footer-nav" aria-label="Footer">
        <Link to="/" className="font-sans text-[11px] font-semibold uppercase tracking-[0.16em] text-mds-cream/75 transition-colors hover:text-mds-goldlt" data-testid="footer-nav-home">Home</Link>
        {NAV_PAGES.map((key) => (
          <Link
            key={key}
            to={PAGES[key].path}
            className="font-sans text-[11px] font-semibold uppercase tracking-[0.16em] text-mds-cream/75 transition-colors hover:text-mds-goldlt"
            data-testid={`footer-nav-${key}`}
          >
            {PAGES[key].label}
          </Link>
        ))}
      </nav>

      <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-mds-cream/15 pt-8 sm:flex-row sm:items-center">
        <p className="font-body text-xs text-mds-cream/60">
          <span className="font-bold">© 2005–{new Date().getFullYear()} Inspire Giving.</span> All rights reserved.
        </p>
        <div className="flex flex-col items-start gap-2 sm:items-end" data-testid="footer-inspire-giving">
          <a
            href="https://studio4forty.com"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-opacity duration-300 hover:opacity-100"
            data-testid="footer-inspire-giving-link"
          >
            <img src="/brand/ig-logo-white-h.webp" alt="Inspire Giving" className="h-auto w-52 opacity-85 sm:w-56" draggable={false} />
          </a>
          <p className="font-sans text-[10px] uppercase tracking-[0.2em] text-mds-cream/60">Produced In Partnership With</p>
        </div>
      </div>
    </div>
  </footer>
);
